module.exports = __webpack_public_path__ + "aff02da7e7ae57458d19b5baa4e60c3c.jpg";